import { useEffect } from "react";

// Shows the wait/busy cursor across the whole page while `isBusy` is true.
// The <body> class is reference-counted so two busy components can't clear each
// other's cursor, and it is released on unmount so closing a modal mid-request
// never leaves the page stuck on the wait cursor. Styles live in index.css.

const BUSY_CURSOR_CLASS = "busy-cursor";
let activeBusyCount = 0;

const useBusyCursor = (isBusy) => {
  useEffect(() => {
    if (!isBusy) {
      return undefined;
    }
    activeBusyCount += 1;
    document.body.classList.add(BUSY_CURSOR_CLASS);

    return () => {
      activeBusyCount = Math.max(0, activeBusyCount - 1);
      if (activeBusyCount === 0) {
        document.body.classList.remove(BUSY_CURSOR_CLASS);
      }
    };
  }, [isBusy]);
};

export default useBusyCursor;
